$(document).ready(function() {

    var actLang, activeLang;

    /*** DETAILSEITE UNTERKUNFT - TRUST YOU EINBINDUNG ***/
    if ($(".ttgTrustYouScoreDetailSite").length) {

        var trustYouId = $(".ttgTrustYouScoreDetailSite").attr("data-trustYouId");
        actLang = $("#ttgSpecialData").attr("data-actLanguage");
        if (actLang == "cs") {
            activeLang = "cz";
            actLang = "en";
        } // if
        var trustYouApi = "https://api.trustyou.com/hotels/" + trustYouId + "/seal.json?lang=" + actLang;
        $.ajax({
            url: trustYouApi,
            dataType: 'jsonp',
            success: function(result) {
                if (result.response.score == null) {
                    return;
                }
                var trustYouResponseHTML = "<div class='ttgTrustYouScore col-md-2 col-sm-1 col-xs-2'>" + result.response.score + "</div>";
                var tmpTrustYouDescriptionDetail = result.response.score_description;
                if (activeLang == "cz") {
                    trustYouResponseHTML += "<div class='ttgTrustYouScoreDescription col-md-7 col-sm-4 col-xs-7'>" + getTrustYouDescriptionCZ(tmpTrustYouDescriptionDetail) + "</div>";
                } else {
                    trustYouResponseHTML += "<div class='ttgTrustYouScoreDescription col-md-7 col-sm-4 col-xs-7'>" + tmpTrustYouDescriptionDetail + "</div>";
                } // if
                //trustYouResponseHTML += "<div class='ttgTrustYouScoreDescription'>"+result.response.score_description+"</div>";
                trustYouResponseHTML += "<div class='ttgTrustYouLogo col-md-3 col-sm-2 col-xs-3'><img src='//cdn.ttg.at/fileadmin/templates/global/images/metasuche/trustYouLogo.png' alt='trustYou Logo' class='responsiveImage'></div><div class='ttgClearBoth'></div>";
                $(".ttgTrustYouScoreDetailSite").append(trustYouResponseHTML);
            }
        });
    } // if
    /*** // DETAILSEITE UNTERKUNFT - TRUST YOU EINBINDUNG ***/

    /*** Listen Seite Unterkünfte Trust You Einbindung ***/
    if ($(".ttgListItemVermieter").length) {

        actLang = $("#ttgSpecialData").attr("data-actLanguage");
        if (actLang == "cs") {
            activeLang = "cz";
            actLang = "en";
        } // if
        var trustYouIdArray = [];
        var tourdataAndTrustYouArray = [];
        var trustYouApiURL = "https://api.trustyou.com/bulk?key=7a3712c8-18f1-4b0b-9901-06dd1d0024f6&request_list=[";
        $(".ttgListItemVermieter").each(function() {
            if ($(this).attr("data-tourdataAndTrustYouId")) {
                var tourdataAndTrustYouId = $(this).attr("data-tourdataAndTrustYouId").split("xxx");
                var tourdataId = tourdataAndTrustYouId[0];
                var trustYouId = tourdataAndTrustYouId[1];
                var item = '/hotels/' + trustYouId + '/seal.json?lang=' + actLang;
                trustYouIdArray.push(item);
                // nur Elemente mit TrustYouId speichern
                if (trustYouId) {
                    tourdataAndTrustYouArray.push(tourdataAndTrustYouId);
                } // if
            } // if
        });

        var itemAndScore = [];
        // Trust You Request nur ausführen wenn auch Elemente in der Liste gibt
        if (trustYouIdArray.length > 0) {
            trustYouApiURL += '"' + trustYouIdArray.join('","') + '"]';
            $.ajax({
                url: trustYouApiURL,
                dataType: 'jsonp',
                success: function(result) {
                    $.each(result.response.response_list, function(i, item) {
                        if (result.response.response_list[i].response !== null) {
                            var tmpTrustYouScore = result.response.response_list[i].response.score;
                            if (tmpTrustYouScore > 0) {
                                var tmpTrustYouDescription = result.response.response_list[i].response.score_description;
                                var tmpTrustYouId = result.response.response_list[i].response.ty_id;
                                var trustYouListResponseHTML = "<div class='row'>";
                                trustYouListResponseHTML += "<div class='ttgTrustYouLogo col-md-4 col-sm-4 col-xs-3'><img src='//cdn.ttg.at/fileadmin/templates/global/images/metasuche/trustYouLogo.png' alt='TrustYou Logo'/></div>";
                                trustYouListResponseHTML += "<div class='ttgTrustYouScoreListHolder col-md-8 col-sm-8 col-xs-9'>";
                                trustYouListResponseHTML += "<div class='ttgTrustYouScoreList'>" + tmpTrustYouScore + "</div>";
                                if (activeLang == "cz") {
                                    trustYouListResponseHTML += "<div class='ttgTrustYouScoreDescriptionList'>" + getTrustYouDescriptionCZ(tmpTrustYouDescription) + "</div>";
                                } else {
                                    trustYouListResponseHTML += "<div class='ttgTrustYouScoreDescriptionList'>" + tmpTrustYouDescription + "</div>";
                                } // if
                                trustYouListResponseHTML += "</div>";
                                trustYouListResponseHTML += "</div>";
                                // die TourdataObjekt ID noch über die trustYouId herausfinden ... da es in Einzelfällen sein kann, dass ein Betrieb die selbe TrustYouId hat und sonst zwei Bewertungen bei einem Objekt aufscheinen würden
                                $.each(tourdataAndTrustYouArray, function(i, item) {
                                    if (tmpTrustYouId == item[1]) {
                                        itemAndScore.push({
                                            'tourdataId': item[0],
                                            'trustYouId': item[1],
                                            'response': trustYouListResponseHTML
                                        });
                                    } // if
                                });
                            }
                        }
                    });

                    // wir brauchen ein unique Object Array
                    var newItemAndScore = [];
                    var uniqueItemAndScore = [];
                    $.each(itemAndScore, function(i, item) {
                        if (!uniqueItemAndScore[item.tourdataId]) {
                            newItemAndScore.push(item);
                            uniqueItemAndScore[item.tourdataId] = item;
                        } // if
                    });

                    $.each(newItemAndScore, function(i, item) {
                        $("#ttgTrustYouId-" + item.tourdataId + "xxx" + item.trustYouId).append(item.response).fadeIn("slow");
                    });
                }
            });
        } // if
    } // if
    /*** // Listen Seite Unterkünfte Trust You Einbindung ***/

});

function getTrustYouDescriptionCZ(trustYouDescription) {

    var descriptionObject = {};
    descriptionObject.notrated = {
        cz: 'Nehodnoceno'
    };
    descriptionObject.poor = {
        cz: 'Nedobrý'
    };
    descriptionObject.mediocre = {
        cz: 'Podprumerný'
    };
    descriptionObject.good = {
        cz: 'Dobrý'
    };
    descriptionObject.verygood = {
        cz: 'Velmi dobrý'
    };
    descriptionObject.excellent = {
        cz: 'Vynikající'
    };

    var trustYouDecriptionText = trustYouDescription.toLowerCase().replace(/ /g, '');
    return descriptionObject[trustYouDecriptionText].cz;

} // function